import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real7 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/leclerc/leclerc1.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc1.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc2.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc2.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc3.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc3.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc4.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc4.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc5.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc5.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc6.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc6.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc7.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc7.jpg")
      },
      {
        original: require("../../assets/images/leclerc/leclerc8.jpg"),
        thumbnail: require("../../assets/images/leclerc/leclerc8.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Pose d'une porte blindée</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real7;